import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

const toLower = text => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.text).includes(toLower(term)))
  }

  return items
}

export default {
  name: 'SelectBillingGroup',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      search: '',
      searched: []
    }
  },
  created() {
    this.$root.$on('select_billing_group_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.searched = this.dataObj.billingGroups;
      });
    },
    onSelect(item) {
      if (this.dataObj.readOnly)
        return;

      if (item == null)
        return;

      for (var i = 0; i < this.dataObj.billingGroups.length; i++) {
        this.dataObj.billingGroups[i].selected = false;
      }

      this.dataObj.billingGroups.filter(a => a.value == item.value)[0].selected = true;
      this.dataObj.GroupId = this.dataObj.billingGroups.filter(a => a.value == item.value)[0].value;
    },
    completeTask(item) {
      if (this.dataObj.readOnly)
        return;

      this.onSelect(item);
      this.dataObj.completeTask();
    },
    searchBillingGroup() {
      if (this.search == '') {
        this.searched = this.dataObj.billingGroups
        return;
      }

      this.searched = searchByName(this.dataObj.billingGroups, this.search);
    }
  },
  
}

